<template>
    <v-container class="pa-0">
        <chart id="bar" :options="option"/>
    </v-container>
</template>

<script>
import ECharts from "vue-echarts"
import "echarts"
import moment from "moment"
moment.locale('pt-BR')
export default {
    components: {
        chart: ECharts,
    },
    data() {
        return {
            option: {}
        }
    },
    watch: {
        list(val) {
            this.chartsBar(val)
        }
    },
    methods: {
        formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        },
        chartsBar(val) {
            let months = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']
            let meses = val.dt_faturamento.map(mes => months[Number(mes.split('-')[1]-1)])
            let legend = meses

            this.option = {
                tooltip: {
                    trigger: 'axis',
                        backgroundColor: 'none',
                    axisPointer: {
                        type: 'line',
                        animation: true,
                    },
                    formatter: ([a,b,c])=>{
                        [a, b, c].forEach(el => el.value = this.formatPrice(el.value)) 
                        return `<div style="border-radius:4px;width:100%;height:auto;background-color:#ffffffd1;border:1px solid #D7DCE6;padding:8px;box-shadow: 0px 1px 8px rgba(215, 220, 230, 0.2), 0px 3px 4px rgba(215, 220, 230, 0.12), 0px 3px 3px rgba(215, 220, 230, 0.14);">
                        <span style="color:#4A4A4A;font-weight:600;font-size:12px;margin-botton:2px;">${a.name}</span><br/>
                        <span style="display:inline-block;margin-right:4px;border-radius:10px;width:9px;height:9px;background-color:${a.color};"></span>${a.seriesName}: R$ ${a.value}<br/>
                        <span style="display:inline-block;margin-right:4px;border-radius:10px;width:9px;height:9px;background-color:${b.color};"></span>${b.seriesName}: R$ ${b.value}<br/>
                        <span style="display:inline-block;margin-right:4px;border-radius:10px;width:9px;height:9px;background-color:${c.color};"></span>${c.seriesName}: ${c.value}%</div>`
                        },
                        
                    textStyle : {
                        color: '#4A4A4A',
                        fontWeight: '600',
                        fontSize: 12,
                    }
                },
                title: {
                    subtext: "Valor (R$)",
                    top: "2%",
                    left: "1%",
                    color: "#4A4A4A",
                },
                grid: {
                    left: '2%',
                    right: '2%',
                    bottom: '0%',
                    top: '16%',
                    containLabel: true
                },
                legend: {
                    right: '10%',
                    data: ['Previsto', 'Faturado', 'Perc. Faturado']
                },
                xAxis: [
                    {
                        type: 'category',
                        data: legend,
                        axisPointer: {
                            type: 'shadow'
                        },
                        axisLine: {
                            show: false,
                        },
                        axisTick: {
                            show: false,
                        },
                        axisLabel: {
                            interval: 0,
                            textStyle: {
                                color: "#4A4A4A",
                                fontSize: 11,
                            },
                        }    
                    }
                ],
                yAxis: [{
                    axisLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLabel: {
                        textStyle: {
                            color: "#4A4A4A",
                        }
                    },
                    splitLine: {
                        lineStyle: {
                            color: "#4a4a4a08",
                        },
                    }
                },
                {
                    type: 'value',
                    scale: true,
                    name: '(%)',
                    max: val.perc_diferenca.reduce((max, item) => item > max? item : max, val.perc_diferenca[0])[0],
                    min: 0,
                    axisLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    }
                }  
                ],
                color: ["#035A27", "#31B1FF", "#ABE1FA"],
                series: [
                    {
                        name: 'Previsto',
                        type: 'bar',
                        data: val.vl_prev_faturamento
                    },
                    {
                        name: 'Faturado',
                        type: 'bar',
                        data: val.vl_faturamento
                    },
                    {
                        name: 'Perc. Faturado',
                        type: 'line',
                        data: val.perc_diferenca,
                        yAxisIndex: 1
                    }
                ],
                animationDuration: 2000
            }
        },
    },
    props: {
        list: Object
    }
}
</script>

<style scoped>
.echarts {
  width: 100%;
  height: 320px;
}
.chart-date {
    font-family: sans-serif;
    font-size: 17px;
    color: black;
}
</style>